import styled from 'styled-components/macro';
import CaptureImage from './img/CareteamIcon.svg';

interface ModalWrapperProps {
  zIndex?: number | string;
}

export const ModalWrapper = styled.div<ModalWrapperProps>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: ${props => props.zIndex || '10'};
`;

export const Divider = styled.div`
  width: 40px;
  height: 10px;
`;

interface HolderProps {
  row?: boolean;
}

export const Holder = styled.div<HolderProps>`
  display: flex;
  flex-direction: ${props => (props.row ? 'row' : 'column')};
  justify-content: center;
  align-items: center;
`;

export const ModalWrapperInner = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 11;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  max-width: 360px;
  background: #ffffff;
  box-shadow: 0px 2px 2px #d3dbf8;
  border-radius: 4px;
  padding: 30px 0;
  @media (max-width: 991px) {
    left: 10px;
    right: 10px;
    width: auto;
    transform: translateY(-50%);
    max-width: inherit;
  }
`;

export const ModalHeader = styled.div`
  color: #6786ff;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  padding: 0 42px;
  text-align: center;
`;

export const ModalBody = styled.div`
  color: #6786ff;
  font-weight: 600;
  font-size: 14px;
  line-height: 30px;
  padding: 0 30px;
  text-align: center;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  outline: none;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #6786ff;
  appearance: none;
  padding: 0;
  &:focus {
    outline: none;
    appearance: none;
  }
`;

interface OkButtonProps {
  center?: string;
}

export const OkButton = styled.button<OkButtonProps>`
  align-self: ${props => (props.center ? 'center' : 'flex-end')};
  margin-right: ${props => (props.center ? '0px' : '30px')};
  padding: 5px 20px;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  background: #6786ff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 15px;
  transition: all 0.3s;
  &:hover {
    background: #250044;
    text-decoration: none;
    color: #ffffff;
  }
`;

export const Message = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #6786ff;
`;

interface ModalMainProps {
  zIndex?: number | string;
}

export const ModalMain = styled.div<ModalMainProps>`
  font-family: 'Poppins';
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
  z-index: ${props => props.zIndex || '10'};
`;

export const ModalInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  z-index: 11;
  top: 45%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  max-width: 360px;
  background: #ffffff;
  box-shadow: 0px 2px 2px #d3dbf8;
  border-radius: 10px;
  padding: 0px 0;
  @media (max-width: 991px) {
    left: 10px;
    right: 10px;
    width: auto;
    transform: translateY(-50%);
    max-width: inherit;
  }
`;

interface WhiteTitleProps {
  small?: boolean;
}

export const WhiteTitle = styled.div<WhiteTitleProps>`
  font-style: italic;
  font-weight: 600;
  font-size: ${props => (props.small ? '14px;' : '20px;')};
  line-height: 25px;
  text-align: center;
  color: #ffffff;
  margin-top: 5px;
  padding: 30px;
`;

export const ContentPopup = styled.div`
  padding: 30px 24px;
  font-size: 14px;
  font-family: Poppins;
`;
export const ChargeOption = styled.div`
  font-size: 14px;
  font-family: Poppins;
  background: #dafff1;
  padding: 12px 8px 20px 8px;
  border-radius: 15px;
  color: #6786ff;
  text-align: center;
  font-weight: 600;
  line-height: 28px;
`;
export const MessagePopup = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
  text-align: center;
  margin-bottom: 20px;
`;
export const ActionPopup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const LinkStyle = styled.a`
  padding: 25px 0px 35px;
  font-size: 14px;
  text-decoration-line: underline;
  font-weight: 600;
  cursor: pointer;
`;
export const UpdateButton = styled.button`
  align-self: center;
  padding: 10px 24px;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  background: #6786ff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 30px;
  transition: all 0.3s;
  &:hover {
    background: #250044;
    text-decoration: none;
    color: #ffffff;
  }
`;

export const ClosePopup = styled.button`
  width: 43px;
  height: 43px;
  background-repeat: no-repeat;
  border: transparent;
  border-radius: 50%;
  position: absolute;
  background-color: white;
  right: -16px;
  top: -16px;
  display: flex;
  background-position: center;
`;

export const ContentSteps = styled.div`
  padding: 0px 30px 24px;
  font-size: 14px;
  font-family: Poppins;
`;

export const MessageCareteam = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #6786ff;
  padding: 0 0px;
  &.bold {
    font-weight: 600;
  }
`;

interface BlueTitleProps {
  small?: boolean;
}

export const BlueTitle = styled.div<BlueTitleProps>`
  font-style: italic;
  font-weight: 600;
  font-size: ${props => (props.small ? '14px;' : '20px;')};
  line-height: 25px;
  text-align: center;
  color: #6786ff;
  margin-top: 5px;
  padding: 10px 30px;
`;

export const CareteamImage = styled.div`
  background-image: url(${CaptureImage});
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0px auto;
  width: 100px;
  height: 103px;
`;
